import Care from 'components/svg/Care'
import CertifiedIcon from 'components/svg/CertifiedIcon'
import DollarCircle from 'components/svg/DollarCircle'
import HeartUsersIcon from 'components/svg/HeartUsersIcon'
import MoonCloudIcon from 'components/svg/MoonCloudIcon'
import NewPill from 'components/svg/NewPill'
import PadlockUser from 'components/svg/PadlockUser'
import ShoppingBagIcon from 'components/svg/ShoppingBagIcon'

export const onlineSolutionsData = [
  {
    icon: ShoppingBagIcon,
    text: 'Entrega em embalagens discretas'
  },
  {
    icon: MoonCloudIcon,
    text: 'Atendimentos flexíveis com horários à noite e aos finais de semana'
  },
  {
    icon: PadlockUser,
    text: 'Seus registros médicos e informações sensíveis são protegidas e confidenciais'
  },
  {
    icon: CertifiedIcon,
    text: 'Encontre médicos que atuam nos melhores hospitais do Brasil'
  },
  {
    icon: DollarCircle,
    text: 'Pague à vista por PIX ou parcele no cartão de crédito'
  },
  {
    icon: NewPill,
    text: 'Tratamentos manipulados de qualidade e feitos sob medida'
  },
  {
    icon: Care,
    text: 'Cuidado e atenção dedicados a cada necessidade'
  },
  {
    icon: HeartUsersIcon,
    text: 'Milhares de clientes atendidos online'
  }
]
